"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStoreAction = void 0;
/**
 * @param {Store} store - Event.
 * @param {Function} callback - Callback.
 * @param {Function} sideEffect - Callback.
 * @returns {Function} Reducer fucntion.
 */
function createStoreAction(store, callback, sideEffect) {
    return function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        if (sideEffect) {
            sideEffect.apply(void 0, params);
        }
        var result = callback.apply(void 0, __spreadArray([store.get()], params, false));
        if (result instanceof Promise) {
            result
                .then(function (data) {
                store.dispatch(data);
            })
                .catch(function (e) {
                store.dispatchError(e);
            });
            return;
        }
        store.dispatch(result);
    };
}
exports.createStoreAction = createStoreAction;
